/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FullWidthECGPreview from '../../components/FullWidthECGPreview';
import styles from './EventHighlightView.css'
import {addHighlight, deleteHighlight} from '../../state'
import { paintSingleLeadWaveform, xScale, yScale } from '../../utils/PaintGraph'
import Grid from "../../components/FullWidthECGPreview/Grid"
import Waveform from "../../components/FullWidthECGPreview/Waveform"
import * as Lib from '../../const'

const EventHighlightView = () => {
    const dispatch = useDispatch()
    const Samples = useSelector((state) => state.annotator.samples)
    const Highlight = useSelector((state) => state.annotator.highlight)
    const seconds = Samples.samples.leadI.length / Samples.frequency
    const height = Lib.MV_BANDWIDTH * Lib.PX_PER_MV+1
    const width = seconds*Lib.PX_PER_SECOND
    const [HighlightCoordinates, setHighlightCoordinates] = useState(null)
    
    const handleMouseClick = (e,lead) => {
        const XScale = xScale(Samples.samples.leadI.length, seconds*Lib.PX_PER_SECOND, 1)
        const timeScale = xScale(Samples.samples.leadI.length,seconds,1)
        const i = Math.floor(XScale.invert(e.nativeEvent.offsetX))
        const range = Samples.frequency * 6 
        let li = i-range/2 
        let ri = i+range/2 
        if (li < 0 ) {
            li = 0
            ri = 1800
        }
        if (ri > Samples.samples.leadI.length) {
            li = Samples.samples.leadI.length-1800
            ri = Samples.samples.leadI.length
        }
        const timestart = timeScale(li).toFixed(2)
        const timeend = timeScale(ri).toFixed(2)
        dispatch(addHighlight({
            LeadData: lead,
            centerIndex: i,
            leftIndex: li,
            rightIndex: ri,
            timestart,
            timeend,
        }))
    }

    const closeHighLight = () => {dispatch(deleteHighlight());setHighlightCoordinates(null)}


    useEffect(() => {
        // console.log(seconds)
        const XScale = xScale(Samples.samples.leadI.length, width, 1)
        const xLeft = Math.floor(XScale(Highlight.leftIndex))
        const xRight = Math.floor(XScale(Highlight.rightIndex))
        setHighlightCoordinates({
            x:xLeft > xRight ? xRight : xLeft,
            y:0,
            x2:xLeft < xRight ? xRight : xLeft,
            y2:101
        })
    }, [Highlight])

    return (
        <React.Fragment>
            <div className={styles.LeadViewHeading}>
                <h2 className={styles.headingText}>
                    Select the 6-Second Highlight for This Report
                </h2>

                {Highlight.LeadData != null && HighlightCoordinates &&
                <React.Fragment>
                    <p className={styles.LeadTitle} style={{color:"#2D9F86"}}>Selected: {Highlight.LeadData} - {`(${Highlight.timestart}s - ${Highlight.timeend}s)`}</p>
                </React.Fragment>
                }
            </div>
            <div className={styles.EventHighlightContainer}>
                {Object.keys(Samples.samples).map(leadName => (
                    <div style={{marginTop:"5px",marginBottom:"10px"}}>
                        <h4 className={styles.LeadTitle} style={{marginBottom:"-2.2rem",marginLeft:".2rem"}}>{leadName}</h4>
                        {/* <svg style={{position:"fixed"}}>
                            <text x="5" y="15" className={styles.LeadTitle}>{leadName}</text>
                        </svg> */}
                        <div className={styles.ecgRowView} onClick={(e)=>handleMouseClick(e,leadName)} key={leadName}>
                            <svg width={width} height={`${height}px`} className={styles.previewGrid}>
                                <g transform="translate(0,0)">
                                <Grid
                                    renderSmallGrid={true}
                                    rowSeconds={seconds}
                                    stripWidthPx={width}
                                    height={height}
                                />
                                <Waveform
                                    capsule={false}
                                    height={height}
                                    samples={Samples.samples[leadName]}
                                    inverted={false}
                                    mainsFreq={Samples.frequency}
                                />
                                </g>
                                {Highlight.LeadData == leadName && HighlightCoordinates &&
                                <React.Fragment>
                                    <rect x={HighlightCoordinates.x} y={HighlightCoordinates.y} width={Math.abs(HighlightCoordinates.x - HighlightCoordinates.x2)} height={Math.abs(HighlightCoordinates.y - HighlightCoordinates.y2)} fill={'#2D9F86'} fillOpacity={'0.25'} />
                                    <text x={HighlightCoordinates.x2 - 25} y={HighlightCoordinates.y2 - 15} onMouseDown={closeHighLight} className={styles.LeadTitleDelete}>[x]</text>
                                </React.Fragment>
                                }
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    )
}

export default EventHighlightView



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/EventHighlightView/EventHighlightView.jsx